module.exports = __webpack_public_path__ + "AiBot_2xwp08172528776006fa4362dabf00c485d4.png";